export const formDefaultValues = {
  firstname: '',
  lastname: '',
  email: '',
}
